import React, { Component } from "react"
import PropTypes from "prop-types"

export default class ScreensizeProvider extends Component {
  static displayName = "ScreensizeProvider"

  static childContextTypes = {
    screensize: PropTypes.string.isRequired
  }

  state = {
    screensize: this.getScreensize()
  }

  getChildContext() {
    return {
      screensize: this.state.screensize
    }
  }

  componentDidMount() {
    this.setState({ screensize: this.getScreensize() })
    window.addEventListener("resize", this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize)
  }

  getScreensize() {
    if (typeof window !== "undefined") {
      if (window.innerWidth <= 615) return "phones"
      if (window.innerWidth <= 768) return "thatUglyInBetweenSize"
      if (window.innerWidth <= 980) return "devWithConsoleOpen"
      if (window.innerWidth >= 1400) return "widescreenFools"
    }
    return "desktop"
  }

  handleResize = e => {
    const nextScreensize = this.getScreensize()
    if (nextScreensize !== this.state.screensize) {
      this.setState({ screensize: nextScreensize })
    }
  }

  render() {
    return React.Children.only(this.props.children)
  }
}



// WEBPACK FOOTER //
// ./src/components/ScreensizeProvider.js